import { render } from "./index.vue?vue&type=template&id=72a14d5e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=72a14d5e&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a14d5e"],['__file',"src/components/DetalhesProcessos/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72a14d5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72a14d5e', __exports__)) {
    console.log('reload')
    api.reload('72a14d5e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=72a14d5e&scoped=true", () => {
    console.log('re-render')
    api.rerender('72a14d5e', render)
  })

}


export default __exports__